import api from './api';

export interface Estrategia {
    nint: number;
    nombre: string;
    tipo: string;
    activo: string;
    descripcion?: string;
    disponibilidades?: number | null;
    bancosCtaCte?: number | null;
    clientes?: number | null;
    otrosCreditos?: number | null;
    bienesDeUso?: number | null;
    proveedores?: number | null;
}

export interface EstrategiaSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
}

export interface EstrategiaPagedResult {
    items: Estrategia[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const estrategiaService = {
    getEstrategias: async (params: EstrategiaSearchParams): Promise<EstrategiaPagedResult> => {
        const response = await api.get<EstrategiaPagedResult>('/api/Estrategia', { params });
        return response.data;
    },

    getEstrategia: async (nint: number): Promise<Estrategia> => {
        const response = await api.get<Estrategia>(`/api/Estrategia/${nint}`);
        return response.data;
    },

    createEstrategia: async (estrategia: Estrategia): Promise<Estrategia> => {
        const response = await api.post<Estrategia>('/api/Estrategia', estrategia);
        return response.data;
    },

    updateEstrategia: async (nint: number, estrategia: Estrategia): Promise<void> => {
        await api.put(`/api/Estrategia/${nint}`, estrategia);
    },

    deleteEstrategia: async (nint: number): Promise<void> => {
        await api.delete(`/api/Estrategia/${nint}`);
    }
};

export default estrategiaService;

